import { render, staticRenderFns } from "./DeleteRole.vue?vue&type=template&id=4fee8beb&scoped=true"
import script from "./DeleteRole.vue?vue&type=script&lang=js"
export * from "./DeleteRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fee8beb",
  null
  
)

export default component.exports